import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import Country from '../../api/entities/Country';
import CountryDataService from '../../api/services/CountryDataService';
type CountryContextType = {
  countries: Country[];
  error: boolean;
};
type Props = {
  children: ReactNode;
};
export const CountryContext = React.createContext<CountryContextType>({
  countries: [],
  error: false,
});
export const CountryProvider = ({ children }: Props): JSX.Element => {
  const [countries, setCountries] = useState<Country[]>([]);
  const [error, setError] = useState<boolean>(false);
  const loadCountries = useCallback(async () => {
    try {
      const countries =
        await CountryDataService.getInstance().getCountriesData();
      setCountries(countries);
      setError(false);
    } catch (error) {
      console.log('failed to initialize countries', JSON.stringify(error));
      setError(true);
    }
  }, []);

  useEffect(() => {
    loadCountries();
  }, [loadCountries]);

  const countryContext: CountryContextType = {
    countries,
    error,
  };
  return (
    <CountryContext.Provider value={countryContext}>
      {children}
    </CountryContext.Provider>
  );
};
